import {
	Button,
	HStack,
	VStack,
	Text,
	H1,
} from '@montel/montelpro-shared-components-v2';
import { FunctionComponent } from 'react';
import { StandardModal } from 'components/common/Modal/StandardModal';
import { Provider } from 'domain/subscription/interfaces/Subscription';

interface DefaultProviderBlacklistUnsavedChangesModalProps {
	isOpen: boolean;
	isLoading?: boolean;
	addedProviders: Provider[];
	removedProviders: Provider[];
	onDiscard: () => void;
	onKeepEditing: () => void;
	onSave: () => void;
}

export const DefaultProviderBlacklistUnsavedChangesModal: FunctionComponent<
	DefaultProviderBlacklistUnsavedChangesModalProps
> = ({
	isOpen,
	isLoading = false,
	addedProviders,
	removedProviders,
	onDiscard,
	onKeepEditing,
	onSave,
}) => (
	<StandardModal
		isOpen={isOpen}
		onClose={onKeepEditing}
		footer={
			<HStack fullWidth justify="flex-end" gap="lg">
				<Button
					text="Keep editing"
					variant="secondary"
					onClick={onKeepEditing}
				/>
				<Button
					text="Discard changes"
					variant="negative"
					onClick={onDiscard}
				/>
				<Button
					text="Save changes"
					variant="primary"
					onClick={onSave}
					isLoading={isLoading}
					loadingText="Saving..."
				/>
			</HStack>
		}
	>
		<VStack gap="md">
			<H1 size="lg">You have unsaved changes</H1>
			{addedProviders.length > 0 && (
				<Text fontStyle="italic">
					These providers were added to the default blacklist:{' '}
					<Text fontStyle="normal">
						<b>
							{addedProviders
								.map((provider) => provider.name)
								.join(', ')}
						</b>
					</Text>
				</Text>
			)}
			{removedProviders.length > 0 && (
				<Text fontStyle="italic">
					These providers were removed from the default blacklist:{' '}
					<Text fontStyle="normal">
						<b>
							{removedProviders
								.map((provider) => provider.name)
								.join(', ')}
						</b>
					</Text>
				</Text>
			)}
			<Text>How would you like to proceed?</Text>
		</VStack>
	</StandardModal>
);
